import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { ApiError, AuthService, UserDetail } from '../../api';
import { userQueryKeys } from '../query-keys-factories/user';

export const useCurrentUser = (
  queryOptions: Omit<
    UseQueryOptions<UserDetail, ApiError, UserDetail, string[]>,
    'queryKey' | 'queryFn'
  > = {}
) => {
  const {
    data: user,
    error: errors,
    ...rest
  } = useQuery({
    queryKey: userQueryKeys.detail('current'),
    queryFn: () => AuthService.authUserRetrieve(),
    retry: false,
    ...queryOptions,
  });

  return {
    user,
    errors,
    ...rest,
  };
};
